import * as React from 'react';
import {useState, useEffect} from 'react';
import {Subscription} from 'rxjs';
import {view, tokens} from '@sail/ui';
import {createKeyframes} from '@sail/engine';
import {
  Conversation,
  ConversationParticipant,
} from '@stripe-internal/conversations-client';

const blink = createKeyframes({
  0: {opacity: 1},
  30: {opacity: 0},
  60: {opacity: 0},
  100: {opacity: 1},
});

type Props = {conversation?: Conversation};

export function BlinkingCursor({conversation}: Props) {
  const [typers, setTypers] = useState<ConversationParticipant[]>([]);

  useEffect(() => {
    if (conversation) {
      const sub = new Subscription();
      sub.add(conversation.typingObservable().subscribe(setTypers));
      return () => sub.unsubscribe();
    }
  }, [conversation]);

  // If no `conversation` was passed, we just always show the blinking
  // cursor. Otherwise we listen for events from the conversation
  const isTyping =
    conversation == null ||
    typers.filter((typer) => typer.id !== conversation.user.id).length > 0;

  if (!isTyping) {
    return null;
  }

  // The extra div is important as it shields this from undesired
  // affects from flexbox, which might collapse this down so it
  // doesn't show up
  return (
    <view.div>
      <view.div
        data-testid="cursor"
        css={{
          animation: `${blink} 1s infinite`,
          height: 18,
          width: 1,
          backgroundColor: tokens.color.text,
        }}
      />
    </view.div>
  );
}
